export const memoizeLast = <A extends unknown[], R>(fn: (...args: A) => R) => {
  let lastArgs: A | undefined;
  let lastResult: R;
  return (...args: A): R => {
    if (
      lastArgs &&
      lastArgs.length === args.length &&
      lastArgs.every((arg, i) => arg === args[i])
    ) {
      return lastResult;
    }
    lastArgs = args;
    lastResult = fn(...args);
    return lastResult;
  };
};
